import { FC } from 'react';

import { SpinIcon } from '../Icons';
import classes from './styles.module.scss';

type SpinnerTypes = 'micro' | 'small' | 'big';

const spinnerSizes = {
  micro: {
    width: 12,
    height: 12
  },
  small: {
    width: 50,
    height: 50
  },
  big: {
    width: 100,
    height: 100
  }
};

export const Spinner: FC<{ type?: SpinnerTypes }> = ({ type = 'small' }) => (
  <div className={classes.spinner}>
    <SpinIcon {...spinnerSizes[type]} />
  </div>
);
